export const PUBLIC_PRODUCT_API_END_POINT  = process.env.RAZZLE_PUBLIC_PRODUCT_API_END_POINT || 'public-products'
export const BASE_API_URL = process.env.RAZZLE_BASE_API_URL
export const TAGS_OF_PRODUCTS_API_END_POINT = process.env.RAZZLE_TAGS_OF_PRODUCTS_API_END_POINT || 'tags-of-products'